import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Lock } from 'lucide-react';

/**
 * PreviewBanner - Shared component for showing preview mode status
 * Used across all R-PAT phase pages when user hasn't unlocked the phase yet
 */
const PreviewBanner = ({ 
  message, 
  actionLabel = 'Go to Dashboard', 
  onAction,
  variant = 'warning' // 'warning' | 'info'
}) => {
  const variantStyles = {
    warning: {
      card: 'bg-amber-50 border-amber-200',
      icon: 'text-amber-600',
      title: 'text-amber-800',
      text: 'text-amber-600'
    },
    info: {
      card: 'bg-blue-50 border-blue-200',
      icon: 'text-blue-600',
      title: 'text-blue-800',
      text: 'text-blue-600'
    }
  };

  const styles = variantStyles[variant] || variantStyles.warning;

  return (
    <Card className={styles.card} data-testid="preview-banner">
      <CardContent className="py-3 flex items-center gap-3">
        <Lock className={`h-5 w-5 ${styles.icon}`} />
        <div className="flex-1">
          <p className={`font-medium ${styles.title}`}>Preview Mode</p>
          <p className={`text-sm ${styles.text}`}>{message}</p>
        </div>
        {onAction && (
          <Button 
            variant="outline" 
            size="sm" 
            onClick={onAction}
            className="ml-auto"
            data-testid="preview-banner-action"
          >
            {actionLabel}
          </Button>
        )}
      </CardContent>
    </Card>
  );
};

export default PreviewBanner;
